import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, sagaMiddleware } from "./store";
import rootSaga from "./store/sagas";

sagaMiddleware.run(rootSaga);

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// Cambio 2: Reemplazar ReactDOM.render por createRoot
const container = document.getElementById("root");
const root = createRoot(container);
root.render(app);
